import React from 'react';
import { useTranslation } from 'react-i18next';
import { Settings as SettingsIcon } from 'lucide-react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const AbsenceBasicInfoSection = ({ formData, updateField, categories }) => {
  const { t } = useTranslation();

  return (
  <div className="space-y-4">
    <h3 className="text-lg font-semibold flex items-center gap-2">
      <SettingsIcon className="h-5 w-5" />
      {t('absenceReasons.form.basicInfo')}
    </h3>

    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="name">{t('absenceReasons.form.name')}</Label>
        <Input
          id="name"
          placeholder={t('absenceReasons.form.namePlaceholder')}
          value={formData.name}
          onChange={(e) => updateField('name', e.target.value)}
        />
      </div>
      <div className="space-y-2">
        <Label htmlFor="code">{t('absenceReasons.form.code')}</Label>
        <Input
          id="code"
          placeholder={t('absenceReasons.form.codePlaceholder')}
          value={formData.code}
          onChange={(e) => updateField('code', e.target.value.toUpperCase())}
          className="font-mono"
        />
      </div>
    </div>

    <div className="space-y-2">
      <Label htmlFor="description">{t('absenceReasons.form.description')}</Label>
      <Textarea
        id="description"
        placeholder={t('absenceReasons.form.descriptionPlaceholder')}
        value={formData.description}
        onChange={(e) => updateField('description', e.target.value)}
        rows={2}
      />
    </div>

    <div className="grid grid-cols-2 gap-4">
      <div className="space-y-2">
        <Label htmlFor="color">{t('absenceReasons.form.color')}</Label>
        <div className="flex gap-2">
          <Input
            id="color"
            type="color"
            value={formData.color}
            onChange={(e) => updateField('color', e.target.value)}
            className="w-20 h-10 cursor-pointer"
          />
          <Input
            type="text"
            value={formData.color}
            onChange={(e) => updateField('color', e.target.value)}
            className="font-mono"
            placeholder="#3B82F6"
          />
        </div>
      </div>
      <div className="space-y-2">
        <Label htmlFor="category">{t('absenceReasons.form.category')}</Label>
        <Select value={formData.category} onValueChange={(v) => updateField('category', v)}>
          <SelectTrigger><SelectValue /></SelectTrigger>
          <SelectContent>
            {categories.map((cat) => (
              <SelectItem key={cat.value} value={cat.value}>
                {cat.icon} {cat.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  </div>
  );
};

export default AbsenceBasicInfoSection;
